import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
    import { THGCar } from '@/interfaces/thg/THGCar';
    import { createTHGCarUpdateData, generateDisplayName } from '@/utils/thg';
    import { getTHGCar, saveTHGCar } from '@/api/thg/cars';
    import { alertError } from '@/utils/dialogs';
    import emitter from '@/utils/mitt';
    import { useRoute } from 'vue-router/composables';
    import THGCarForm from '@/components/thg/cars/THGCarForm.vue';
    import { THGUser } from '@/interfaces/thg/THGUser';
    import { getTHGUser } from '@/api/thg/users';
    import { useTHGGlobalStore } from '@/storenew/thg/global';
    import { ToastProgrammatic as Toast } from 'buefy';
    import { FormMode } from '@/enums/misc';
    import EditTHGCarVRCs from '@/components/thg/cars/EditTHGCarVRCs.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGCar',
  setup(__props) {

    const route = useRoute();

    const currentVin = ref<string | undefined>(undefined);
    const currentYear = ref<number | undefined>(undefined);
    const currentRegDate = ref<string | undefined>(undefined);

    const car = ref<THGCar | null>(null);

    const currentUser = ref<THGUser | null>(null);
    const { currentCountry } = useTHGGlobalStore();

    /**
     * Save the car
     */
    async function saveVehicle() {
        if (!car.value) {
            throw new Error('thg car is undefined');
        }

        emitter.emit('showLoader');

        // do we have to update the vin, year or regdate (it's a potential special additional operation, so check it)
        const updateVin = Boolean(currentVin.value !== car.value.vin);
        const updateYear = Boolean(currentYear.value !== car.value.year);
        const updateRegDate = Boolean(currentRegDate.value !== car.value.registration_date);

        // create the update data
        const updateData = createTHGCarUpdateData(
            car.value,
            currentCountry,
            updateVin,
            updateYear,
            updateRegDate,
        );

        if (!car.value._id) {
            throw new Error('Car ID is undefined.');
        }

        // do the actual update
        const response = await saveTHGCar(car.value._id, updateData);

        if (response.status !== 200) {
            alertError('Fehler', 'Fehler beim Speichern des Fahrzeugs.');
        } else {
            Toast.open({ type: 'is-success', message: 'Fahrzeug wurde erfolgreich gespeichert.' });
        }

        // re-retrieve car to update the file urls (e.g. when changing the FIN)
        await retrieveCar();

        emitter.emit('hideLoader');
    }

    async function fetchUser(userId: string) {
        const response = await getTHGUser(userId);
        const user = response.parsedBody;

        if (!user) {
            throw new Error('cannot get user');
        }

        return user;
    }

    async function retrieveCar() {
        const response = await getTHGCar(route.params.carId);
        const car_obj = response.parsedBody;

        if (!car_obj) {
            throw new Error('Error while fetching car.');
        }

        car.value = car_obj;
        currentVin.value = car_obj.vin;
        currentYear.value = car_obj.year;
        currentRegDate.value = car_obj.registration_date;

        // get the current user object either via route parameter or retrieve it
        if ('user' in route.params && route.params.user) {
            currentUser.value = route.params.user as unknown as THGUser;
        } else if ('userId' in route.params && route.params.userId) {
            currentUser.value = await fetchUser(route.params.userId);
        }
    }

    onMounted(async () => {
        await retrieveCar();
    });

return { __sfc: true,route, currentVin, currentYear, currentRegDate, car, currentUser, currentCountry, saveVehicle, fetchUser, retrieveCar, generateDisplayName, THGCarForm, FormMode, EditTHGCarVRCs }
}

})